<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Chat History
        <small>Search for conversation</small>
      </h1>

    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
          <div class="col-md-4">
              <div class="form">
                  <input v-if="role >= 33" class="form-control" v-model="ip" placeholder="IP adresa"/>
                  <br />
                  <input class="form-control" v-model="nickname" placeholder="Nickname"/>
                  <br />
                  <input class="form-control" v-model="message" placeholder="Message.."/>
                  <br />
                  <select class="form-control" v-model="server" id="select-server">
                      <option v-if="role >= 33" value="">Server: Svi</option>
                      <option v-if="role >= 33 || role == 21" value="1">FFA#1</option>
                      <option v-if="role >= 33 || role == 22" value="2">MINIONS#2</option>
                      <option v-if="role >= 33 || role == 23" value="3">INSTANT MERGE#3</option>
                      <option v-if="role >= 33 || role == 24" value="4">MEGA SPLIT#4</option>
                      <option v-if="role >= 33 || role == 25" value="5">EXPERIMENTAL#5</option>
                      <option v-if="role >= 33 || role == 26" value="6">RAINBOW#6</option>
                      <option v-if="role >= 33 || role == 27" value="7">VIRUS MINES#7</option>
                      <option v-if="role >= 33 || role == 28" value="8">OLD EXP#8</option>
                      <option v-if="role >= 33 || role == 29" value="9">TEAMS#9</option>
                      <option v-if="role >= 33 || role == 29" value="10">TOURNAMENT#10</option>
                  </select>
                  <select class="form-control" v-model="client" name="client" id="select-client" v-if="role >= 33">
                      <option value="">All</option>
                      <option value="0">Main</option>
                      <option value="1">Lite</option>
                      <option value="2">Mobile</option>
                      <option value="4">Facebook App</option>
                  </select>
                  <br />
                  <div class="clearfix"></div>
                  <div v-show="msg !== ''" class="alert alert-danger">
                    {{msg}}
                  </div>
                  <button @click="search()" class="btn btn-info btn-block">Pretraži</button>
              </div>
          </div>
          <div class="col-md-8">
            <div id="datetimepicker12"></div>
          </div>
      </div>
      <br />
      <hr style="box-shadow:1px 1px 1px gray;" />
      <div class="row">
          <div class="col-md-6">
              <div class="chat">
                <div class="chat-title">
                    <div class="panel panel-default">
                      <div class="panel-heading">
                          Rezultati pretrage
                          <span v-show="returnedDateTime != ''">od: {{ returnedDateTime }}</span> /
                          <span v-show="result.length > 0">Broj rezultata: {{ result.length }}</span>
                          <button v-if="role >= 40" type="button" class="btn btn-info btn-sm pull-right" data-toggle="modal" data-target="#myModal">Notes</button>
                          <div class="clearfix"></div>
                      </div>
                    </div>
                </div>
                <div class="chat-box" v-if="result.length > 0">
                    <div data-toggle="tooltip" data-placement="top" :title="item.datetime + ', ' + item.server" :class="[index % 2 == 0 ? 'even' : 'odd', 'chat-message list-group-item']" v-for="(item, index) in result" @click="takeAction(item)">
                        <span class="sender">{{ decoded(item.nickname) }}: </span>
                        <span class="body">{{ decoded(item.message) }}</span>
                    </div>
                    <span class="load-more" v-if="resultLength == 100 && !searching" @click="loadMore()">Load more</span>
                </div>
                <div v-else :class="[searching ? 'alert-info' : 'alert-danger', ' alert']">
                    <p v-show="!searching">Nema rezultata pretrage.</p>
                    <p v-show="searching">Pretražuje se...</p>
                </div>
              </div>
          </div>
          <div class="col-md-6">
              <!-- {{selectedMessage}} -->
              <!-- Default box -->
              <div class="box box-info" v-show="Object.keys(selectedMessage).length !== 0">
                <div class="box-header with-border">
                  <h3 class="box-title">Ban</h3>
                </div>
                <div class="box-body">
                  <div>
                    <form class="form-horizontal">
                      <div class="form-group">
                        <label for="nickname" class="col-sm-2 control-label">Nick</label>
                        <div class="col-sm-10">
                          <input v-model="ban.nickname" type="text" id="nickname" placeholder="Nickname..." class="form-control">
                        </div>
                      </div>
                      <div class="form-group" v-show="role >= 33">
                        <label for="ip-address" class="col-sm-2 control-label">IP</label>
                        <div class="col-sm-10">
                          <input v-model.trim="ban.ip" type="text" id="ip-address" placeholder="IP address" class="form-control">
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="datetimepicker" class="col-sm-2 control-label">Date to</label>
                        <div class="col-sm-10">
                          <input type='text' class="form-control" id='datetimepicker' />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="type" class="col-sm-2 control-label">Ban type</label>
                        <div class="col-sm-10">
                          <select v-model="ban.type" id="type" class="form-control">
                            <option value="1">Game - preusmerava na stranu ban</option>
                            <option value="2">Chat - gasi mu chat</option>
                            <option value="3">Skins - zabrana dodavanja</option>
                            <option value="4">Igra - ubija tab (oprezno)</option>
                            <option value="5">Salje mu poruku iz 'Reasona'</option>
                            <option value="6">Protrese mu ekran svakih 20 sek. Unban da ne trese stalno.</option>
                          </select>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="reason" class="col-sm-2 control-label">Reason</label>
                        <div class="col-sm-10">
                          <textarea v-model="ban.reason" id="reason" class="form-control" rows="2"></textarea>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <div class="box-footer">
                  <div>
                    <p class="text-danger text-left"><u>{{ ban.date_to != '' ? 'Banuj do: ' + ((new Date(ban.date_to)).toUTCString()) : '' }}</u></p>
                    <p class="text-danger text-right">{{ ban.msg }}</p>
                    <button @click="banPlayer()" type="button" class="btn btn-info pull-right">
                      Ban
                    </button>
                  </div>
                </div>

                <div class="box-footer">
                      <p>Poruka: {{ decoded(selectedMessage.message) }}</p>
                      <p>Vreme: {{ selectedMessage.datetime }}, Klijent: {{ selectedMessage.client }}</p>
                      <table v-if="role >= 40" class="table table-striped">
                          <tr v-for="(value, key) in ipinfo">
                            <td>{{ key }}</td>
                            <td>{{ value }}</td>
                          </tr>
                      </table>
                </div>
              </div>
          </div>
      </div>

      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog modal-md">
          <div class="modal-content">
            <div class="modal-body">
              <form>
                <textarea class="form-control" rows="6" style="min-width: 100%" maxlength="5000" v-model="localStorageNicknames"></textarea>
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" @click="saveLocalNicknames()" class="btn btn-default">Save</button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import $ from 'jquery'
  import 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'History',
    data: function () {
      return {
        nickname: '',
        ip: '',
        client: '',
        server: '',
        message: '',
        datetime: '',
        role: 1,
        result: [],
        resultLength: 0,
        searching: 0,
        form: new Form({}),
        msg: '',
        selectedMessage: {},
        returnedDateTime: '',
        localStorageNicknames: '',
        ipinfo: {
          'city': '',
          'country': '',
          'region': '',
          'isp': '',
          'status': ''
        },
        ban: {
          nickname: '',
          ip: '',
          date_to: '',
          reason: '',
          type: 0,
          msg: ''
        }
      }
    },
    computed: {
    },
    methods: {
      search: function () {
        if (this.datetime === '') {
          this.msg = 'Choose a date'
          return 0
        }
        if (this.ip !== '') {
          this.ip = this.ip.trim()
        }
        var self = this
        this.searching = 1
        let data = {
          nickname: encodeURI(this.nickname),
          ip: this.ip,
          datetime: this.datetime,
          server: this.server,
          message: encodeURI(this.message),
          client: this.client,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log')
        }
        self.result = []
        self.resultLength = 0
        $('[data-toggle="tooltip"]').tooltip()
        this.msg = ''
        this.form.post(baseUrl + 'Admin/readMessage', data).then(function (result) {
          if (Number(result.status) === 1) {
            self.result = result.messages.slice()
            self.resultLength = self.result.length
            self.returnedDateTime = result.datetime
            setTimeout(function () {
              $('[data-toggle="tooltip"]').tooltip()
            }, 500)
          } else {
            $('.chat-box').html('Došlo je do greške: ', result.msg)
            self.msg = result.msg
          }
          self.searching = 0
        }, function (reason) {
          // rejection
          alert(reason)
        })
      },
      decoded: function (encoded) {
        if (encoded === '') {
          return ''
        }
        try {
          return decodeURI(encoded)
        } catch (err) {
          return encoded
        }
      },
      saveLocalNicknames: function () {
        localStorage.setItem('savedNicknames', this.localStorageNicknames)
        $('#myModal').modal('close')
      },
      loadMore: function () {
        if (this.result.length === 0) {
          return 0
        }
        var LastId = this.result[this.result.length - 1]
        this.searching = 1
        let data = {
          nickname: encodeURI(this.nickname),
          ip: this.ip,
          datetime: this.datetime,
          server: this.server,
          message: encodeURI(this.message),
          last_id: LastId['id'],
          client: this.client,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log')
        }
        var self = this
        self.resultLength = 0
        $('[data-toggle="tooltip"]').tooltip()
        this.msg = ''
        this.form.post(baseUrl + 'Admin/readMessageNext', data).then(function (result) {
          if (Number(result.status) === 1) {
            self.result = self.result.concat(result.messages.slice())
            self.resultLength = result.messages.slice().length
            self.returnedDateTime = result.datetime
            setTimeout(function () {
              $('[data-toggle="tooltip"]').tooltip()
            }, 500)
          } else {
            $('.chat-box').html('Došlo je do greške: ', result.msg)
            self.msg = result.msg
          }
          self.searching = 0
        }, function (reason) {
          // rejection
          alert(reason)
        })
      },
      takeAction: function (item) {
        this.selectedMessage = item
        this.ban.nickname = this.decoded(item.nickname)
        this.ban.ip = item.ip
        if (this.role >= 40) {
          this.getIpInfo(item.ip)
        }
      },
      getIpInfo: function (ip) {
        var self = this
        // self.ipinfo = {}
        this.form.post('https://ipapi.co/' + ip + '/json/', {}).then(function (result) {
          // var jsonResult = JSON.parse(result)
          // self.ipinfo.assign(result)
          self.ipinfo['city'] = result['city'] + ' / ' + result['region'] + ' / ' + result['postal']
          self.ipinfo['country'] = result['country_name']
          self.ipinfo['region'] = result['region']
          self.ipinfo['isp'] = result['org']
          self.ipinfo['status'] = true
          // for (var key in result) {
          //   self.ipinfo[key] = result[key]
          //   console.log(key, result[key], self.ipinfo)
          // }
        }, function (reason) {
          // rejection
        })
      },
      banPlayer: function () {
        if (this.ban.date_to === '') {
          this.ban.msg = 'Choose date'
          return 0
        }
        if (this.ban.ip === '') {
          this.ban.msg = 'Must enter IP address'
          return 0
        }
        if (this.ban.type < 1 || this.ban.type > 6) {
          this.ban.msg = 'Choose type'
          return 0
        }
        var self = this
        let data = {
          nickname: encodeURI(this.ban.nickname),
          ip: this.ban.ip,
          reason: this.ban.reason,
          date_to: this.ban.date_to,
          type: this.ban.type,
          token_header: localStorage.getItem('token_header'),
          token_log: localStorage.getItem('token_log'),
          by: this.$store.state.nickname
        }
        this.ban.msg = ''
        this.form.post(baseUrl + 'Admin/banUser', data).then(function (result) {
          if (Number(result.status) === 1) {
            self.ban.nickname = ''
            self.ban.reason = ''
            self.ban.date_to = ''
            self.ban.type = 0
            self.ban.ip = ''
          } else {
            self.ban.msg = result.msg
          }
        }, function (reason) {
          // rejection
        })
      }
    },
    mounted: function () {
      this.role = this.$store.state.role
      var self = this

      if (this.role >= 33) {
        $('#select-server').addClass('half-select')
      }
      window.$ = $
      $(document).ready(function () {
        $('#select-server').val($('#select-server option:first').val())
        self.server = $('#select-server option:first').val()

        $('#datetimepicker12').datetimepicker({
          inline: true,
          sideBySide: true,
          // format: 'YYYY-MM-DD HH:mm',
          locale: 'sr',
          ignoreReadonly: true,
          useCurrent: true
        })
        .on('dp.show', function () {
          return $(this).data('DateTimePicker').defaultDate(new Date())
        })
        .on('dp.change', function (e) {
          self.msg = ''
          self.datetime = e.date.utc().local().format('YYYY-MM-DD HH:mm:ss')
        })

        // for ban form
        $('#datetimepicker').datetimepicker({
          locale: 'sr'
        })
        $(document).on('dp.change', '#datetimepicker', function (e) {
          self.ban.date_to = e.date.utc().local().format()
        })

        if (localStorage.savedNicknames) {
          self.localStorageNicknames = localStorage.savedNicknames
        }
        // $('[data-toggle="tooltip"]').tooltip()
      })
    }
  }
</script>

<style scoped>
  .chat {
      /* border: 1px solid #000; */
  }
  .chat-box {
    overflow-y: auto;
    border: 1px solid #337ab7;
    border-radius: 5px;
    min-height: 300px;
    max-height: 400px;
    padding: 5px;
  }
  .load-more {
    float: right;
    cursor: pointer;
  }
  .chat-message {
      /* -webkit-box-shadow:0px 1px 1px #de1dde;
      -moz-box-shadow:0px 1px 1px #de1dde;
      box-shadow:0px 1px 1px #de1dde; */
      cursor: pointer;
  }
  .chat-message .sender {
      font-weight: 700;
  }
  .even .sender {
    color: darkblue;
  }

  .odd .sender {
    color: darkred;
  }
  .half-select, #select-client {
    width: 50%;
    float: left;
    margin-bottom: 20px;
  }
  #select-client {
  }
  .alert {
    padding: 5px;
  }
    /* width */
  ::-webkit-scrollbar {
      width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: #f1f1f1;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #888;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #555;
  }
  @media screen and (max-width: 992px) {
  }
  @media screen and (max-width: 768px) {
  }
  @media screen and (max-width: 480px) {
  }
</style>



// WEBPACK FOOTER //
// History.vue?6144c4f7